import { useApolloClient } from '@apollo/client/react'
import React from 'react'
import ReactSelectAsync from 'react-select/async'
import type { SelectAsyncProps } from './index'
import { setupLoadOptions, setupOptionLabel } from './index'
import { useReactSelect } from './useReactSelect'
import { useDebouncedLoadOptions } from './useDebouncedLoadOptions'
import { useLoadOptionsFailure } from './useLoadOptionsFailure'
import { asyncLoadingMessage } from './AsyncLoadingMessage'

export const SelectAsync = ({
  getOptionLabel,
  labelKey = 'label',
  loadOptions,
  dataLoadOptions,
  defaultOptions = true,
  loadingMessage,
  ...props
}: SelectAsyncProps) => {
  const client = useApolloClient()
  const loadFailure = useLoadOptionsFailure(props.components)

  if (!getOptionLabel) {
    getOptionLabel = setupOptionLabel(labelKey)
  }

  if (!loadOptions) {
    loadOptions = setupLoadOptions({
      client,
      dataLoadOptions,
      getOptionLabel,
      onLoadSettled: loadFailure.onLoadSettled,
      latestRequest: loadFailure.latestRequest,
    })
  }

  const debouncedLoadOptions = useDebouncedLoadOptions(loadOptions)
  const properties = useReactSelect(props)

  return (
    <ReactSelectAsync
      {...properties}
      loadOptions={debouncedLoadOptions}
      getOptionLabel={getOptionLabel}
      defaultOptions={defaultOptions}
      cacheOptions={true}
      components={loadFailure.components}
      loadingMessage={loadingMessage ?? asyncLoadingMessage}
    />
  )
}
